import React from 'react';
import { Smartphone, Shield, BookOpen, Users } from 'lucide-react';

const Highlights = () => {
  const highlights = [
    {
      icon: <Users size={32} />,
      title: "Community",
      description: "Connect with believers worldwide."
    },
    {
      icon: <Shield size={32} />,
      title: "Protected",
      description: "Safe environment for all ages."
    },
    {
      icon: <Smartphone size={32} />,
      title: "Mobile First",
      description: "Seamless experience on iOS & Android."
    },
    {
      icon: <BookOpen size={32} />,
      title: "Scripture",
      description: "Daily devotionals and bible study."
    }
  ];

  return (
    <div className="highlights-section">
      <div className="container">
        <div className="highlights-grid">
          {highlights.map((item, index) => (
            <div key={index} className="highlight-item">
              <div className="highlight-icon">{item.icon}</div>
              <h4>{item.title}</h4>
              <p>{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Highlights;
